import axios from '../utilities/Axios';

export default {
  getProficiencies: async () => (await axios.get('/proficiency')).data.data,
}

